module.exports = __webpack_public_path__ + "fonts/Muli-Bold.28c1a15b.ttf";